<template>
  <v-card
    outlined
    class="upload-box"
    :class="uploadBoxClasses"
    :style="{
      width: isReadOnly ? '120px' : '170px',
      height: isReadOnly ? '120px' : '160px',
      pointerEvents: isReadOnly ? 'none' : 'auto',
    }"
    @click="triggerUpload"
  >
    <v-card-text class="pa-1">
      <img
        v-if="preview"
        :src="preview"
        alt="Profile Photo"
        class="uploaded-image"
      />
      <div v-else class="upload-instructions">
        <v-icon size="48" class="mb-2">mdi-camera</v-icon>
        <p class="mb-0">Upload Photo *</p>
        <p class="caption mb-0">
          Please select a file with *.png, *.jpeg, or *.jpg extension.
        </p>
      </div>
      <input
        ref="fileInput"
        type="file"
        accept=".png, .jpeg, .jpg"
        class="d-none"
        @change="handleFileChange"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    error: {
      type: Boolean,
    },
    photo: {
      type: Object,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      preview: null, // Stores preview of uploaded image
    };
  },
  computed: {
    uploadBoxClasses() {
      return {
        "error-border": this.error && !this.preview, // Add red border if error
      };
    },
  },
  watch: {
    photo: {
      immediate: true, // Run on component mount
      handler(newPhoto) {
        if (newPhoto?.file_binary) {
          this.preview = `data:image/png;base64,${newPhoto.file_binary}`;
        } else {
          this.preview = null;
        }
      },
    },
  },
  methods: {
    triggerUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result; // Set new preview
        };
        reader.readAsDataURL(file);
        this.$emit("input", file);
      }
    },
  },
};
</script>

<style scoped>
.upload-box {
  border: 1px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
}

.upload-box:hover {
  border-color: #777;
}

.error-border {
  border: 2px solid red !important;
}

.upload-instructions {
  text-align: center;
}

.upload-instructions .caption {
  color: #666;
  font-size: 0.75rem;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
